import { render, staticRenderFns } from "./AddEditRole.vue?vue&type=template&id=8b1ecc5c&scoped=true"
import script from "./AddEditRole.vue?vue&type=script&lang=js"
export * from "./AddEditRole.vue?vue&type=script&lang=js"
import style0 from "./AddEditRole.vue?vue&type=style&index=0&id=8b1ecc5c&prod&lang=css"
import style1 from "./AddEditRole.vue?vue&type=style&index=1&id=8b1ecc5c&prod&lang=scss&scoped=true"
import style2 from "./AddEditRole.vue?vue&type=style&index=2&id=8b1ecc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1ecc5c",
  null
  
)

export default component.exports